import axios, { AxiosResponse } from "axios";
import { Tool, ToolVersion } from "graphql/_Types";
import { getEnvVar } from "ideas.env";
import { getRequestHeaders } from "utils/getRequestHeaders";

type CreateToolVersionDraftRequest = {
  tool: Tool["id"];
};

type CreateToolVersionDraftResponse = {
  tool_version: Pick<ToolVersion, "id" | "version">;
};

export const createToolVersionDraft = async (
  data: CreateToolVersionDraftRequest,
) => {
  const headers = await getRequestHeaders();
  return axios.post<
    CreateToolVersionDraftRequest,
    AxiosResponse<CreateToolVersionDraftResponse>
  >(getEnvVar("URL_TRS_TOOL_VERSION_DRAFT"), data, { headers });
};
